<h1 mat-dialog-title>
  {{ ("missingRequiredFields" | i18n) || "Fehlende Pflichtfelder" | titlecase }}
</h1>
<div mat-dialog-content>
  <div class="row">
    <div
      class="col"
      *ngIf="data.requiredFields.dateOfBirth && !data.user.dateOfBirth">
      <mat-form-field>
        <mat-label>{{
          ("dateOfBirth" | i18n) || "Geburtstag" | titlecase
        }}</mat-label>
        <input
          matInput
          [value]="
            updatedFields.dateOfBirth ? (updatedFields.dateOfBirth | date) : ''
          "
          readonly
          (click)="dateOfBirthDatePicker.open()" />
        <input
          matInput
          name="user-date-of-birth-datepicker"
          (dateChange)="selectDateOfBirth($event)"
          (click)="dateOfBirthDatePicker.open()"
          (keydown)="(false)"
          [matDatepicker]="dateOfBirthDatePicker"
          hidden />
        <mat-datepicker-toggle
          matSuffix
          [for]="dateOfBirthDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #dateOfBirthDatePicker></mat-datepicker>
      </mat-form-field>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button
    mat-button
    (click)="cancel()">
    {{ ("close" | i18n) || "close" | uppercase }}
  </button>
  <button
    data-cy="dialog-confirm"
    [disabled]="
      (data.requiredFields.dateOfBirth && !updatedFields.dateOfBirth) || false
    "
    mat-button
    [mat-dialog-close]="updatedFields">
    {{ ("confirm" | i18n) || "confirm" | uppercase }}
  </button>
</div>
